import { render, staticRenderFns } from "./VinesAppeal.vue?vue&type=template&id=11269496&scoped=true"
import script from "./VinesAppeal.vue?vue&type=script&lang=js"
export * from "./VinesAppeal.vue?vue&type=script&lang=js"
import style0 from "./VinesAppeal.vue?vue&type=style&index=0&id=11269496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11269496",
  null
  
)

export default component.exports